module.exports = __webpack_public_path__ + "img/calll.7c981ac3.png";